import GroupCell from './src/group-cell.vue';

export default GroupCell;
